export const data = [
    {
        id: 1,
        name: "Simyacı",
        author: "Paulo Coelho",
        price: 9.99,
        image:
            "https://images-na.ssl-images-amazon.com/images/I/51eqjXwFzwL._SX344_BO1,204,203,200_.jpg"
    },
    {
        id: 2,
        name: "Yüzyıllık Yalnızlık",
        author: "Gabriel García Márquez",
        price: 19.99,
        image:
            "https://images-na.ssl-images-amazon.com/images/I/51A1ZxGf94L._SY291_BO1,204,203,200_QL40_ML2_.jpg"
    },
    {
        id: 3,
        name: "Annemi Bir Kez Daha Görebilsem",
        author: "Zana Muhsen",
        price: 16.99,
        image:
            "https://content.babil.com/urun/13df0fdbdfbe477d8c8ee30d2e15292c/Front/Big"
    },
    {
        id: 4,
        name: "Ekmek Kavgası",
        author: "Orhan Kemal",
        price: 19.99,
        image:
            "https://images-na.ssl-images-amazon.com/images/I/41BJdviD3TL._SX340_BO1,204,203,200_.jpg"
    },
    {
        id: 5,
        name: "Aşk",
        author: "Elif Şafak",
        price: 25.99,
        image:
            "https://images-na.ssl-images-amazon.com/images/I/414N7XbRE%2BL._SX344_BO1,204,203,200_.jpg"
    }
];
